import { render, staticRenderFns } from "./NavigationBar.vue?vue&type=template&id=0c62b82e&scoped=true&"
import script from "./NavigationBar.vue?vue&type=script&lang=js&"
export * from "./NavigationBar.vue?vue&type=script&lang=js&"
import style0 from "./NavigationBar.vue?vue&type=style&index=0&id=0c62b82e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c62b82e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VIcon,VNavigationDrawer})
